const getConfig = () => {
   const ACTIVE_AUTH = Number.parseInt(process.env.ACTIVE_AUTH || '0');

     return {
       mainDomain: process.env.WORDPRESS_URL,
       replaceDomain: process.env.REPLACE_DOMAIN || process.env.WORDPRESS_URL,
       endpointApi: process.env.ENDPOINT_API,
       pathPage: process.env.PAGE_PATH,
       pathForm: process.env.FORM_PATH,
       cached: process.env.CACHED_TIME || -1,
       gaId: process.env.NEXT_PUBLIC_GA_ID,
       gtmId: process.env.NEXT_PUBLIC_GTM_ID,
       isAuthActive: ACTIVE_AUTH === 1,
       recaptchaKey: process.env.RECAPTCHA_KEY || "",
       baererKey: process.env.BAERER_KEY || "",
     };
}

export default getConfig;